import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgPaperIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      strokeWidth={2}
      fill="none"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit={10}
    >
      <path d="M51 45V3H7v52a6 6 0 0 0 6 6" />
      <path d="M19 55a6 6 0 0 1-6 6h40a6 6 0 0 0 6-6v-4H19Z" />
      <path data-color="color-2" d="M17 16h24M17 27h24M17 38h24" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgPaperStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgPaperIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const PaperIcon: any = SvgPaperStyle;
export default PaperIcon;
